import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectModalTypes } from '../../../../../core/legacy/reducers/modals';
import editProjectSections from '../../../../../core/project/commands/EditProjectSections';
import { currentProjectIdQuery, selectedProjectSectionsQuery } from '../../../../../core/project/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import { Input } from '../../../../session/list-sessions/styles';
import { useProjectSnackbar } from '../../ProjectSnackbarContext';

const EditProjectSectionAssigneeModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedProjectSections = useAppSelector(selectedProjectSectionsQuery);
    const checkedProjectSectionsIds = checkedProjectSections.map((s) => s.id);
    const currentProjectId = useAppSelector(currentProjectIdQuery);
    const { setSnackbarMessage } = useProjectSnackbar();

    const [assignee, setAssignee] = useState('');

    useEffect(() => {
        const assignees = checkedProjectSections
            .map((ps) => ps.assignee)
            .filter((a) => a !== undefined && a !== null)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (assignees.size === 1) {
            setAssignee(assignees.values().next().value as string);
        } else {
            setAssignee('');
        }
    }, [checkedProjectSections]);

    const onValidate = async () => {
        if (!currentProjectId) {
            setSnackbarMessage(t('projectList.error.noProjectSelected'));

            return;
        }

        try {
            await dispatch(
                editProjectSections({
                    projectSectionData: {
                        assignee: assignee === '' ? null : assignee,
                    },
                    projectSectionIds: checkedProjectSectionsIds,
                }),
            ).unwrap();
            setAssignee('');
        } catch (err) {
            console.error('Error editing project sections:', err);
            setSnackbarMessage(t('projectList.error.default'));
        }
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ProjectModalTypes.PROJECT_SECTION_EDIT_ASSIGNEE}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('projectList.modals.editAssignee')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={assignee}
                    type="text"
                    onChange={(e) => setAssignee(e.target.value)}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditProjectSectionAssigneeModal;
